import { GlobalSharedService } from './../../global.shared.service';
import { AfterContentInit, Component, ComponentFactoryResolver, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Levels } from 'src/shared/logger/levels.enum';
import { LoggerService } from 'src/shared/logger/logger.service';
import { folderAccess } from 'src/shared/models/folderAccess.model';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmationComponent } from '../dialog-confirmation/dialog.confirmation.component';

@Component({
  selector: 'app-lm-lists',
  templateUrl: './lm-lists.component.html',
  styleUrls: ['./lm-lists.component.css'],
  providers: [GlobalSharedService, DatePipe]
})

export class LmListsComponent implements FormsModule, OnInit, AfterContentInit {
  title = 'Select folders to allow access to them';
  masterSelected: boolean;
  editMode: boolean = false;
  marketList: folderAccess[];
  marketsReceivedIds: number[] = [];
  accessArr: any;
  newSelectedMarketList: folderAccess[];
  marketNotPicked: boolean;
  butCol: string = 'gray';
  myDate = new Date();

  constructor(
    public dialogRef: MatDialogRef<LmListsComponent>,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private globalService: GlobalSharedService,
    private loggerService: LoggerService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: { userId: number, isEditMode: boolean }
  ) {
    this.masterSelected = false;
    this.marketList = [];
    this.myDate = new Date(Date.now());

  }
  ngAfterContentInit(): void {
    this.getUserMappedList();
  }

  ngOnInit(): void {
    this.marketNotPicked = true;
    this.getAccessList();
    if (this.data?.isEditMode) {
      this.editMode = true;

    }
  }

  getUserMappedList() {

    this.globalService.getUserAccessMappingFolders(this.data?.userId).subscribe(userMappedFolders => {
      
     setTimeout(() => {
      for (var i of userMappedFolders.data) {
        for (var f = 0; f < this.marketList.length; f++) {
          if (this.marketList[f].id == i.folder_id) {
            this.marketList[f].isSelected = true;
          }
        }
      }
     }, 100);
      

    }, err => {
      this.loggerService.log("LmListsComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
    })
  }

  getAccessList() {
    this.globalService.getAllAccessFolders().subscribe(allItems => {
      this.marketList = allItems?.data;
      for (var i = 0; i < this.marketList.length; i++) {
        this.marketList[i].isSelected = false;
      }

    }, err => {
      this.loggerService.log("LmListsComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
    })
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.marketList.every(item => item.isSelected)
  }

  onItemSelect(): void {
    this.newSelectedMarketList = [];
    this.accessArr = [];
    for (var i = 0; i < this.marketList.length; i++) {
      if (this.marketList[i].isSelected) {
        this.newSelectedMarketList.push(this.marketList[i]);


      }
    }
    for (var iarr = 0; iarr < this.newSelectedMarketList.length; iarr++) { this.accessArr.push(this.newSelectedMarketList[iarr].id); }
    this.marketNotPicked = false;
    this.butCol = 'blue';
  }

  checkUncheckAll() {
    for (var i = 0; i < this.marketList.length; i++) {
      this.marketList[i].isSelected = this.masterSelected;
    }
    this.onItemSelect();

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']

    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onOKClick() {
    if (this.editMode) {
      this.openConfirmationDialog();
    } else {
      this.dialogRef.close(this.newSelectedMarketList);
    }

  }

  openConfirmationDialog(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Confirm updating user access", message: "Please confirm or cancel user access request" },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        for (let idObj of this.newSelectedMarketList) {
          this.marketsReceivedIds.push(idObj.id)
        }
        this.globalService.updateAccessFolders(this.data.userId, this.marketsReceivedIds).subscribe(data => {

          this.openSnackBar("User access has been updated.", "Done");
          this.dialogRef.close();

        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
          this.dialogRef.close();

        })
      }
    });
  }



}
